export const LAZY_COMPONENTS = {
    MADE_ON_FIVERR: 'made_on_fiverr',
    TESTIMONIALS: 'testimonials',
    FIB_BANNER: 'fib_banner',
    FIVERR_GUIDES: 'fiverr_guides',
    SIGNUP: 'signup',
    LOGO_MAKER_BANNER: 'logo_maker_banner'
};
